import React from 'react'
import Fab from '@material-ui/core/Fab';
import { withStyles } from '@material-ui/styles';

const classes = {
    reportFab: {
        backgroundColor: '#b14d9b',
        color: 'white',
        border: '2px solid white',
        marginBottom: '1rem',
        width: '80%',
        display: 'inline-flex',
        justifyContent: 'space-between',
        height:'4rem',
        fontSize:'1.2rem'
    }
};

class ReportOption extends React.Component {
    render() {
        const { classes } = this.props;

        return (
        <Fab className={classes.reportFab} variant="extended" aria-label="like" onClick={this.props.setReportScore}>
            <span>{this.props.text}</span>
            <span>{this.props.score}</span>
        </Fab>)
    }
}

export default withStyles(classes)(ReportOption);